import { APP_SCHEMA_VERSION, SCHEMA_VERSION_KEY } from "../constants/schemaVersion";
import { performLogoutAndResetPreferences } from "./logout";

export const initializeSessionValues = async () => {
  const loggedIn = Boolean(localStorage.getItem("authToken"));
  if (!loggedIn) return false;

  // Schema-version guard: if the persisted state predates the current schema,
  // force-reset so we don't render against stale fallback_org / fallback_location.
  const storedSchemaVersion = Number(localStorage.getItem(SCHEMA_VERSION_KEY));
  if (!storedSchemaVersion || storedSchemaVersion < APP_SCHEMA_VERSION) {
    performLogoutAndResetPreferences();
    return false;
  }

  // INITIALIZING LOCATION
  const fallbackOrg = localStorage.getItem("fallback_org");
  if (!fallbackOrg) return false;
  const orgData = JSON.parse(fallbackOrg)

  const sessionOrgId = sessionStorage.getItem("acc_id");

  if (!sessionOrgId) {
    sessionStorage.setItem("acc_id", orgData?.id);
    sessionStorage.setItem("acc_name", orgData?.name);
    sessionStorage.setItem("schema_name", orgData?.schema_name);
  }

  // INITIALIZING LOCATION
  const fallbackLoc = localStorage.getItem("fallback_location");
  if (!fallbackLoc) return false;

  const sessionLoc = sessionStorage.getItem("current_loc");

  if (!sessionLoc) {
    sessionStorage.setItem("current_loc", fallbackLoc);
  }

  return true;
};
